module.exports = __webpack_public_path__ + "static/media/rank3.ebc75c12.svg";